//
export default [
    {
        text: "#",
        value: "id",
    },
    {
        text: "numero",
        value: "number",
    },
    /*{
        text: "modulo",
        value: "guard_name",
    },*/
    {
        text: "nombre",
        value: "name",
    },
    {
        text: "token",
        value: "token",
    },
    {
        text: "fecha de creación",
        value: "created_at",
        align: "right",
        format: "datetime",
    },
]